"use strict";

module.exports = function (column) {
  return !this.opts.descOrderColumns.includes(column);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/initial-order-ascending.js
// module id = 1612
// module chunks = 64